module.exports = __webpack_public_path__ + "media/images/patterns/footer-mobile-nl-daa3ddac420786b5efd541359f2feb33.svg";